import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import MainHero from '../modules/hero-module/main-hero';
import Layout from '@components/layout';
import SEO from '@components/seo';
import CareerDetails from '@components/career/career-details';
import { jobPostingSchemaJson } from '@components/schema';

export const pageQuery = graphql`
  query($jobId: Int!, $breadcrumbRegex: String!) {
    pageData: jobOrder(jobOrderId: { eq: $jobId }) {
      jobOrderId
      isPublic
      title
      publicDescription
      dateLastPublished
      dateEnd
      payRate
      publishedCategory {
        name
      }
      address {
        address1
        city
        state
        zip
      }
      employmentType
    }
    breadcrumbList: allContentfulSeo(filter: { pageUrl: { regex: $breadcrumbRegex } }) {
      nodes {
        pageUrl
        pageTitle
      }
    }
  }
`;

const JobDetails = ({ location, data }) => {
  const {
    pageData: {
      jobOrderId,
      title,
      address,
      publicDescription,
      dateLastPublished,
      dateEnd,
      employmentType,
      payRate,
    },
    breadcrumbList,
  } = data;

  const { address1, city, state, zip } = address;

  const heroTitle = {
    titleSize: 'header100_small',
    textColor: 'white',
    slashColor: 'null',
    columns: 0,
    title: title,
  };

  const link = {
    internalUrl: '/careers/',
  };
  const breadcrumbs = breadcrumbList && breadcrumbList.nodes;

  const metaDescription = publicDescription
    .replace(/(<([^>]+)>)/gi, '')
    .replace(/&nbsp;/g, ' ')
    .substring(0, 160);

  const seo = {
    pageUrl: `/careers/${jobOrderId}/`,
    pageTitle: `${title} - ${address.city}, ${address.state} | STAND 8 Careers`,
    indexibility: 'Indexable',
    metaDescription: {
      metaDescription: metaDescription,
    },
    socialSharingImage: {
      file: {
        url:
          '//images.ctfassets.net/q9zkntem569v/tiuz3EkLgQGIlW0fSVTSG/abe715f82025b4f7f9f7f7938fbded34/STAND_8_Careers.jpg',
      },
    },
    customSchemaJson: jobPostingSchemaJson({
      title,
      description: metaDescription,
      dateLastPublished: new Date(dateLastPublished),
      dateEnd: new Date(dateEnd),
      employmentType,
      address: address1,
      city,
      state,
      zip,
      payRate,
    }),
  };

  return (
    <Layout location={location} footer={true} breadcrumbs={breadcrumbs}>
      {seo && <SEO data={seo} location={location} />}
      <MainHero
        type="dark-purple-double-slash"
        breadcrumbLink={link}
        breadcrumb="CAREERS"
        backgroundColor="darkPurple"
        heroTitle={heroTitle}
      />
      <CareerDetails data={data.pageData} location={location} />
    </Layout>
  );
};

JobDetails.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default JobDetails;
